<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    targetUserName: string;
    targetUserImage: string;
    intermediateUserName: string;
    intermediateUserImage: string;
    isClickable?: boolean;
  }>(),
  {
    targetUserName: '',
    targetUserImage: '',
    intermediateUserName: '',
    intermediateUserImage: '',
    isClickable: false,
  }
);

const hasIntermediateUser = computed(() => {
  return props.intermediateUserName.trim() !== '' || props.intermediateUserImage.trim() !== '';
});
</script>

<template>
  <section class="tw-avatar-names">
    <div class="avatars" :class="{ single: !hasIntermediateUser }">
      <tw-user-avatar
        class="primary-image"
        size="2.2rem"
        letter-size="1rem"
        :is-clickable="isClickable"
        :image-url="targetUserImage"
        :last-name="targetUserName.split(' ')[1] || ''"
        :first-name="targetUserName.split(' ')[0] || ''"
      />

      <template v-if="hasIntermediateUser">
        <tw-user-avatar
          class="secondary-image"
          size="2.2rem"
          letter-size="1rem"
          :is-clickable="isClickable"
          :image-url="intermediateUserImage"
          :last-name="intermediateUserName.split(' ')[1] || ''"
          :first-name="intermediateUserName.split(' ')[0] || ''"
        />
      </template>
    </div>

    <section class="info">
      <p class="user-names">
        {{ targetUserName }}<template v-if="hasIntermediateUser">, {{ intermediateUserName }}</template>
      </p>
      <slot></slot>
    </section>
  </section>
</template>

<style scoped lang="scss">
.tw-avatar-names {
  display: flex;

  .avatars {
    position: relative;
    width: 4rem;
    min-width: 4rem;
    height: 3rem;
    min-height: 3rem;

    &.single {
      .primary-image {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .primary-image,
  .secondary-image {
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
  }

  .primary-image {
    top: -10%;
    left: 35%;
    transform: translateX(-50%);
    z-index: 2;
  }

  .secondary-image {
    top: 60%;
    left: 65%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .info {
    display: flex;
    flex-direction: column;
    .user-names {
      font-weight: 800;
      white-space: nowrap;
      margin: 0;
    }
  }
}
</style>
